<template>
  <div id="container">
    <div class="edit-or-add-content">
      <!-------------- 合同总览 -------------->
      <contract-overview
        ref="contractOverviews"
        @supplierContractNumber="supplierContractNumberList"
        v-show="$route.query.type !== '生成合同'"
      ></contract-overview>
      <!-------------- 供应商信息 -------------->
      <customer-module
        :supplier-data.sync="supplierData"
        @onAddSupplier="onAddSupplier"
        ref="supplierInformationRefs"
      ></customer-module>

      <!-------------- 产品选型 -------------->
      <product-information
        @productTypesChoosing="productTypesChoosing"
        @productTypesRefresh='productTypesRefresh'
        v-show="$route.query.type === '生成合同'"
      ></product-information>
      <!-------------- 产品清单 -------------->
      <el-inventory
        @inventory="inventory"
        :deductionAmount="supplierData.deductionAmount"
        @inventoryIsTrue="inventoryIsTrue"
        ref="elInventoryRefs"
        v-show="$route.query.type !== '生成合同'"
      ></el-inventory>
      <!-------------- 账期设置 -------------->
      <account-period-setting
        ref="accountPeriodSettingRefs"
        @purchaseContractOther="purchaseContractOther"
        v-show="$route.query.type !== '生成合同'"
      ></account-period-setting>
       <!-------------- 收货信息 -------------->
      <goods-receiving-information
      @onInitialGoods='onInitialGoods'
      @getGoods='goodsParams'
        ref="goodsReceivingInformationRefs"
        v-show="$route.query.type !== '生成合同'"
      ></goods-receiving-information>
      <!-------------- 盖章合同上传 -------------->
      <sealed-contract-upload v-show="isShow" ref="sealedContractUploadRefs"></sealed-contract-upload>
      <!------------ 工单日志 ------------>
      <operation-log-and-flow v-if="$route.query.type !=='生成合同'" :flowLabel="flowLabel" :id="pcbId"></operation-log-and-flow>
      <!-------------- 二次确认 -------------->
      <open-or-close-dialog
        ref="openOrCloseRefs"
        @onUpdataState="onUpdataState"
        :title="title"
        :content="content"
      ></open-or-close-dialog>
      <!-------------- 审核不通过 -------------->
      <disapprove-dialog
        @updatePurchase="updatePurchase"
        @updatePurchaseApprovalState="updatePurchaseApprovalState"
        v-show="$route.query.type === '审核不通过'||$route.query.type === '审核驳回'"
        ref="disapproveRefs"
      ></disapprove-dialog>
    </div>

    <!-------------- 未签订合同底部 -------------->
    <div class="edit-fixed-bottom" v-if="$route.query.type !== '已作废'&&$route.query.type !== '审核驳回'">
      <div
        :style="{
          'margin-bottom': $route.query.type === '盖章审批' ? '0px' : '10px'
        }"
      >
        <el-button
          v-show="$route.query.type === '生成合同'"
          @click="onGenerateContract(1)"
          type="primary"
        >生成合同</el-button>
        <el-button
          v-show="
            $route.query.type === '待审核' || $route.query.type === 'het'
          "
          @click="onGenerateContract(2)"
          type="primary"
        >申请审批合同</el-button>
        <el-button
          v-show="$route.query.type === '审核通过待签署'"
          @click="contractLook"
          type="primary"
        >合同预览</el-button>
        <el-button v-show="$route.query.type === '审核通过待签署'" @click="contractUpload">合同下载</el-button>
        <el-button v-show="$route.query.type === '审核通过待签署'" @click="onContractSealUpload">合同盖章上传</el-button>
        <el-button
          v-show="
            $route.query.type === '审核通过待签署' ||
              $route.query.type === '审核驳回'||
              $route.query.type === '审核不通过'
          "
          :type="$route.query.type === '审核驳回' ? 'primary' : ''"
          @click="onGenerateContract(4)"
        >重新提交审核</el-button>
        <el-button
          v-show="
            $route.query.type === '待审核' ||
              $route.query.type === '审核不通过' ||
              $route.query.type === '审核通过待签署' ||
              $route.query.type === '审核驳回'
          "
          @click="onGenerateContract(3)"
        >合同作废</el-button>
      </div>
      <div style="display: flex;padding-bottom:10px;">
        <i class="el-icon-warning-outline" style="margin-top:4px;"></i>
        <span
          v-show="$route.query.type === '生成合同'&&$route.query.data !=='purchase'"
          class="look-text"
        >生成说明：选择供应商及产品后，点击生成合同进入合同制单页</span>
        <span
          v-show="$route.query.type === '生成合同'&&$route.query.data ==='purchase'"
          class="look-text"
        >生成说明：选择供应商后，点击生成合同进入合同制单页</span>

        <span
          class="look-text"
          v-show="
            $route.query.type === '待审核' || $route.query.type === '审核不通过'
          "
        >
          生成说明：合同通过审批后，允许重新申请审批
          <br />
          <span
            class="look-text"
            v-show="contractOverviews.contractFrom ==='采购计划'"
          >合同作废后，采购清单内产品将退回原采购清单，需重新执行。所对应的抵扣金额也会加回该供应商抵扣金额。</span>
          <span
            class="look-text"
            v-show="contractOverviews.contractFrom ==='直备采购'"
          >合同作废后，将无法恢复。所对应的抵扣金额将会加回该供应商抵扣金额。</span>
        </span>
        <span class="look-text" v-show="$route.query.type === '审核中'">已提交合同审批，请等待审核</span>
        <span class="look-text" v-show="$route.query.type === '审核通过待签署'">
          合同盖章上传后，需与原合同内容做对比。重新提交审批后，合同状态更改为待审核，需重新发起审批流程。
          <br />
          <span
            class="look-text"
            v-show="contractOverviews.contractFrom ==='采购计划'"
          >合同作废后，采购清单内产品将退回原采购清单，需重新执行。所对应的抵扣金额也会加回该供应商抵扣金额。</span>
          <span
            class="look-text"
            v-show="contractOverviews.contractFrom ==='直备采购'"
          >合同作废后，将无法恢复。所对应的抵扣金额将会加回该供应商抵扣金额。</span>
        </span>
        <span class="look-text" v-show="$route.query.type === '盖章审批'">采购盖章合同已提交审批，请等待审核</span>
        <span class="look-text" v-show="$route.query.type === '审核驳回'">
          驳回原因：审核驳回时上级填写的驳回原因
          <br />重新提交审批后，合同状态更改为待审核，需重新发起审批流程。
          <br />
          <span
            class="look-text"
            v-show="contractOverviews.contractFrom ==='采购计划'"
          >合同作废后，采购清单内产品将退回原采购清单，需重新执行。所对应的抵扣金额也会加回该供应商抵扣金额。</span>
          <span
            class="look-text"
            v-show="contractOverviews.contractFrom ==='直备采购'"
          >合同作废后，将无法恢复。所对应的抵扣金额将会加回该供应商抵扣金额。</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import {
  purchaseContractBase,
  queryByPcbId,
  purchaseContractBaseUpdate,
  queryApprovalAll,
  updatePurchaseApprovalState,
  addPurchaseContractBaseSuId
} from '@/api/purchase/purchasePlanList'
import { queryUploadPcb, addPurchaseLog } from '@/api/purchase/purchaseManage'

import { uploadDown } from '@/util/tool'
import OpenOrClose from '@/components/OpenOrClose/index' // 二次确认
import productInformation from './productInformation' // 产品信息
import customerModule from '@/components/checkLayout/module/supplierModule' // 供应商信息
import contractOverview from './contractOverview' // 合同总览
import accountPeriodSetting from './accountPeriodSetting' // 账期设置
import goodsReceivingInformation from './goodsReceivingInformation'
import inventory from './inventory' // 产品清单
import disapproveDialog from '../../dialog/disapproveDialog' // 审核不通过
import operationLogAndFlow from '@/components/OperationLog/operationLogAndFlow' // 工单日志
import sealedContractUpload from '../../../../sell/personageManagement/components/contractList/sealedContractUpload'
import * as NP from 'number-precision'
export default {
  components: {
    'open-or-close-dialog': OpenOrClose,
    'customer-module': customerModule,
    'product-information': productInformation,
    'contract-overview': contractOverview,
    'account-period-setting': accountPeriodSetting,
    'el-inventory': inventory,
    'operation-log-and-flow': operationLogAndFlow,
    'sealed-contract-upload': sealedContractUpload,
    'disapprove-dialog': disapproveDialog,
    'goods-receiving-information': goodsReceivingInformation
  },
  data () {
    return {
      onInitialGood: {},
      deductionAmountPurcase: 0,
      pcbId: 0,
      contractState: '',
      checked: false,
      accountPeriod: {},
      contractOverviews: {},
      supplierData: {},
      id: '',
      queryParams: {}, // 待审核时候数据
      information: '', // 供应商信息
      title: '', // 生成合同标题
      content: '', // 生成合同内容
      flowLabel: '签署流程',
      isShow: false,
      list: [],
      params: {
        purchaseContractBaseProductVo: { deductionAmount: 0 }

      },
      supplierContractNumber: ''
    }
  },
  mounted () {
    this.pcbId = this.$route.query.pcbId
    if (
      this.$route.query.pcbId !== undefined &&
      this.$route.query.type === '待审核'
    ) {
      this.queryBySpId()
    }
    if (
      this.$route.query.pcbId !== undefined &&
      this.$route.query.type !== '待审核'
    ) {
      this.queryApprovalAll()
    }
  },
  methods: {
    // 合同下载
    contractUpload () {
      addPurchaseLog(this.$route.query.pcbId).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('合同下载成功')
        } else {
          this.$message.error(res.data.msg)
        }
      })
      queryUploadPcb(this.$route.query.pcbId).then((res) => {
        if (res.data.code === 200) {
          uploadDown(
            this.$store.state.https + res.data.obj.fileUrl,
            this.supplierContractNum
          )
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    // 合同预览
    contractLook () {
      this.$router.push({
        name: 'contractPreviewLook',
        query: {
          pcbId: this.$route.query.pcbId,
          pcbNumber: this.supplierContractNum
        }
      })
    },
    updatePurchase () {
      this.onGenerateContract(4)
    },
    updatePurchaseApprovalState () {
      updatePurchaseApprovalState(this.$route.query.pcbId, 5)
        .then((res) => {
          if (res.data.code === 200) {
            this.$router.push({
              name: 'createContract',
              query: { type: '审核通过待签署', pcbId: this.$route.query.pcbId }
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 审核中
    queryApprovalAll () {
      queryApprovalAll(this.$route.query.pcbId)
        .then((res) => {
          if (res.data.code === 200) {
            this.contractOverviews = res.data.obj.purchaseContractBasesVo
            if (+this.$route.query.stamp === 1) {
              this.onContractSealUpload()
            }
            this.$refs.contractOverviews.onInitial(
              res.data.obj.purchaseContractBasesVo
            )
            this.contractState =
              res.data.obj.purchaseContractBasesVo.contractState // 合同状态
            if (
              this.contractState === 5 &&
              this.$route.query.type !== '审核通过待签署'
            ) {
              this.$router.push({
                name: 'createContract',
                query: {
                  type: '审核通过待签署',
                  pcbId: this.$route.query.pcbId
                }
              })
            }
            if (
              this.contractState === 7 &&
              this.$route.query.type !== '审核不通过'
            ) {
              this.$router.push({
                name: 'createContract',
                query: { type: '审核不通过', pcbId: this.$route.query.pcbId }
              })
            }
            if (
              this.contractState === 8 &&
              this.$route.query.type !== '审核驳回'
            ) {
              this.$router.push({
                name: 'createContract',
                query: { type: '审核驳回', pcbId: this.$route.query.pcbId }
              })
            }
            if (
              this.contractState === 3 &&
              this.$route.query.type !== '履行中'
            ) {
              this.$router.push({
                name: 'contractDetails',
                query: { type: '履行中', pcbId: this.$route.query.pcbId }
              })
            }

            this.supplierContractNum =
              res.data.obj.purchaseContractBasesVo.pcbNumber
            this.supplierData = res.data.obj.purchaseContractBaseProductVo
            this.accountPeriodSettingList =
              res.data.obj.purchaseContractContentAllVo
            this.$refs.accountPeriodSettingRefs.onInitial(
              res.data.obj.purchaseContractBasesVo.purchaseTotal,
              this.accountPeriodSettingList
            )
            // 收货信息
            this.$refs.goodsReceivingInformationRefs.onInitial(
              res.data.obj.goodContentVO
            )
            if (res.data.obj.purchaseContractApprovalVo.isOpenExtime === 0) {
              this.checked = false
            } else {
              this.checked = true
            }

            this.$refs.elInventoryRefs.onInitial(
              res.data.obj.purchaseContractApprovalVo,
              res.data.obj.purchaseContractBasesVo.contractFrom,
              this.checked
            )
            this.supplierContractNumber =
              res.data.obj.purchaseContractBasesVo.supplierContractNumber
            if (this.$route.query.type === '审核不通过') {
              this.supplierContractNumber =
                res.data.obj.purchaseContractBasesVo.supplierContractNumber
              this.$refs.disapproveRefs.onInitial(
                res.data.obj.exPlain,
                '审核不通过'
              )
            }
            if (this.$route.query.type === '审核驳回') {
              this.supplierContractNumber =
                res.data.obj.purchaseContractBasesVo.supplierContractNumber
              this.$refs.disapproveRefs.onInitial(
                res.data.obj.exPlain,
                '审核驳回'
              )
            }
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    inventoryIsTrue (val) {
      this.checked = val
    },
    // 采购清单传回来的数据
    inventory (val, total, deductionAmount) {
      this.deductionAmountPurcase = deductionAmount
      this.contractOverviews.purchaseTotal = total
      this.contractOverviews.accountsPayable = total
      this.contractOverviews.accountsOutstanding = total
      if (this.$route.query.type === '待审核') {
        this.$refs.accountPeriodSettingRefs.onInitial(
          this.contractOverviews.purchaseTotal,
          this.accountPeriod
        )
        this.$refs.contractOverviews.onInitial(this.contractOverviews)
      } else {
        this.$refs.accountPeriodSettingRefs.onInitial(
          this.contractOverviews.purchaseTotal,
          this.accountPeriodSettingList
        )
      }
      const params = JSON.parse(JSON.stringify(val))
      this.params.purchaseProductVoList = []
      for (let i = 0; i < params.length; i++) {
        const purchaseProductVoList = {
          cbRemind: params[i].cbRemind,
          discountPrice: params[i].discountPrice,
          payMoney: params[i].actuallyPirce,
          proExtype: params[i].proExtype,
          pcbExtimeValue: params[i].pcbExtimeValue,
          pccId: params[i].pccId
        }
        this.params.purchaseProductVoList.push(purchaseProductVoList)
      }
    },
    // 账期传回来的数据
    purchaseContractOther (list, val, price) {
      if (val.payType === '约定账期') {
        this.params.purchaseContractAppointment = {
          pcbId: '',
          appointType: '',
          appointValue: '',
          replenMark: val.replenMark
        }
        this.params.purchaseContractAppointment.pcbId = this.$route.query.pcbId
        this.params.payType = val.payType
        this.params.purchaseContractAppointment.appointType =
          val.purchaseContractAppointment.appointType
        this.params.purchaseContractAppointment.appointValue =
          val.purchaseContractAppointment.appointValue
        this.params.purchaseContractOtherPayment = null
      } else {
        this.params.payType = val.payType
        this.params.purchaseContractAppointment = null
        this.params.purchaseContractOtherPayment = {
          replenMark: val.replenMark
        }
        this.params.purchaseContractOtherPayment.pcbId = this.$route.query.pcbId

        for (let i = 0; i < list.length; i++) {
          if (list[i].payType === '预付款') {
            this.params.purchaseContractOtherPayment.isAdvance = 1
            this.params.purchaseContractOtherPayment.advanceAmount =
              list[i].money
            this.params.purchaseContractOtherPayment.advanceAmountProportion =
              NP.strip(list[i].proportion / 100)
          }
          if (list[i].payType === '货款') {
            this.params.purchaseContractOtherPayment.goodAmount = list[i].money
            this.params.purchaseContractOtherPayment.goodAmountProportion = NP.strip(list[i].proportion / 100)
          }
          if (list[i].payType === '质保金') {
            this.params.purchaseContractOtherPayment.isGuarantee = 1
            this.params.purchaseContractOtherPayment.guaranteeAmount =
              list[i].money
            this.params.purchaseContractOtherPayment.guaranteeAmountProportion =
              NP.strip(list[i].proportion / 100)
            this.params.purchaseContractOtherPayment.guaranteeTime = price
          }
        }
        if (this.params.purchaseContractOtherPayment.isAdvance !== 1) {
          this.params.purchaseContractOtherPayment.isAdvance = 0
        }
        if (this.params.purchaseContractOtherPayment.isGuarantee !== 1) {
          this.params.purchaseContractOtherPayment.isGuarantee = 0
        }
      }
    },
    // 收货信息返回的信息
    goodsParams(val) {
      this.params.storageId = val.storageId
    },
    onInitialGoods(val) {
      this.params.storageId = val.storageId
      this.onInitialGood = val
    },
    supplierContractNumberList (val) {
      this.params.supplierContractNumber = val
    },
    // 待审核
    queryBySpId () {
      queryByPcbId(this.$route.query.pcbId)
        .then((res) => {
          if (res.data.code === 200) {
            if (res.data.obj.purchaseContractContentAllVo.payType !== null) {
              this.params = res.data.obj
            }
            this.contractOverviews = res.data.obj.purchaseContractBasesVo
            this.$refs.contractOverviews.onInitial(
              res.data.obj.purchaseContractBasesVo
            )
            this.supplierData = res.data.obj.purchaseContractBaseProductVo
            this.accountPeriod = res.data.obj.purchaseContractContentAllVo
            this.$refs.accountPeriodSettingRefs.onInitial(
              res.data.obj.purchaseContractBasesVo.purchaseTotal,
              res.data.obj.purchaseContractContentAllVo
            )
            this.$refs.elInventoryRefs.onInitial(
              res.data.obj.purchaseUnsignVoList,
              res.data.obj.purchaseContractBasesVo.contractFrom
            )
            // 收货信息
            this.$refs.goodsReceivingInformationRefs.onInitial(
              res.data.obj.goodContentVO
            )
            this.supplierContractNumber =
              res.data.obj.purchaseContractBasesVo.supplierContractNumber
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 产品选型返回的数据
    productTypesChoosing (val) {
      this.list = val
    },
    productTypesRefresh(val) {
      this.list = val
    },
    // 供应商信息返回值
    onAddSupplier (val) {
      this.information = val.suId
    },
    // 底部按钮
    onGenerateContract (type) {
      if (type === 1) {
        if (this.$route.query.data === 'purchase') {
          let isFalse = false
          this.list.forEach(element => {
            if (element.proExtype === null && !isFalse) {
              this.$message.error('请选择类型!')
              isFalse = true
            } else if (this.information === '' && !isFalse) {
              this.$message.error('请选择供应商!')
              isFalse = true
            }
          })
          if (!isFalse) {
            this.title = '生成合同'
            this.content = '请确认是否生成合同？'
            this.$refs.openOrCloseRefs.onInitial(type)
          }
        } else {
          if (this.information === '' || this.list.length === 0) {
            this.$message.error('请补全信息')
          } else {
            this.title = '生成合同'
            this.content = '请确认是否生成合同？'
            this.$refs.openOrCloseRefs.onInitial(type)
          }
        }
      } else if (type === 2) {
        let data = 0
        this.params.purchaseProductVoList.forEach((item, index) => {
          if (item.proExtype === null && data === 0) {
            data++
            this.$message.error('请设置类型！')
          }
          if (item.pcbExtimeValue === 0 && data === 0) {
            this.$message.error('货期不能为零！')
            data++
          }
        })
        if (data === 0) {
          this.params.pcbId = this.$route.query.pcbId
          if (
            this.params.purchaseContractAppointment !== null &&
            this.params.purchaseContractAppointment.appointType === undefined
          ) {
            this.$message.error('请选择账期设置约定条件')
          } else if (
            this.params.purchaseContractAppointment !== null &&
            this.params.purchaseContractAppointment.appointValue === undefined
          ) {
            this.$message.error('请选择账期设置约定天数')
          } else if (
            this.params.purchaseContractOtherPayment !== null &&
            this.params.purchaseContractOtherPayment.isAdvance === 1 &&
            this.params.purchaseContractOtherPayment.advanceAmount === 0
          ) {
            this.$message.error('请设置账期设置')
          } else if (
            this.params.purchaseContractOtherPayment !== null &&
            this.params.purchaseContractOtherPayment.isAdvance === 1 &&
            this.params.purchaseContractOtherPayment.advanceAmount === null
          ) {
            this.$message.error('请设置账期设置')
          } else if (
            this.params.purchaseContractOtherPayment !== null &&
            this.params.purchaseContractOtherPayment.isGuarantee === 1 &&
            this.params.purchaseContractOtherPayment.guaranteeTime === ''
          ) {
            this.$message.error('质保期限不能为空')
          } else if (
            this.params.purchaseContractOtherPayment !== null &&
            this.params.purchaseContractOtherPayment.isGuarantee === 1 &&
            this.params.purchaseContractOtherPayment.guaranteeAmount === null
          ) {
            this.$message.error('请设置账期设置')
          } else if (
            this.params.purchaseContractOtherPayment !== null &&
            this.params.purchaseContractOtherPayment.isGuarantee === 1 &&
            this.params.purchaseContractOtherPayment.guaranteeAmount === 0
          ) {
            this.$message.error('请设置账期设置')
          } else if (this.supplierData.deductionAmount < this.deductionAmountPurcase) {
            this.$message.error('抵扣总额不能大于供应商抵扣金额！')
          } else if (
            this.params.storageId === null && this.onInitialGood.flag === true) {
            this.$message.error('请设置收货信息')
          } else {
            this.title = '提交审批'
            this.content = '请确认是否提交审批？'
            this.$refs.openOrCloseRefs.onInitial(type)
          }
        }
      } else if (type === 3) {
        if (this.contractOverviews.contractFrom === '采购计划') {
          this.title = '确认作废'
          this.content =
            '合同作废后，采购清单内产品将退回原采购计划，需重新执行。 '
          this.$refs.openOrCloseRefs.onInitial(type)
        } else if (this.contractOverviews.contractFrom === '直备采购') {
          this.title = '合同作废'
          this.content = '请确认是否合同作废，一旦作废无法恢复！'
          this.$refs.openOrCloseRefs.onInitial(type)
        }
      } else if (type === 4) {
        this.title = '确认重新提交审批'
        this.content = '确认后合同状态更改为待审核，需重新发起审批流程。'
        this.$refs.openOrCloseRefs.onInitial(type)
      }
    },
    // 合同盖章上传
    onContractSealUpload () {
      this.isShow = true
      setTimeout(() => {
        const num = this.$refs.sealedContractUploadRefs.$el.offsetTop
        document.querySelector('.el-main').scrollTop = num
      }, 100)
      this.$refs.sealedContractUploadRefs.getList(
        this.$route.query.pcbId,
        2,
        this.contractOverviews.contractFrom
      )
    },
    // 再次确认
    onUpdataState (type) {
      if (type === 1) {
        if (this.$route.query.data === 'purchase') {
          const params = {}
          params.orderContractPurchaseListVoList = this.list
          addPurchaseContractBaseSuId(this.information, params)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('已生成合同，请设置合同账期！')
                this.$router.push({
                  name: 'createContract',
                  query: { type: '待审核', pcbId: res.data.obj }
                })
                this.queryBySpId()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => {
              console.log(err)
            })
        } else {
          const queryParams = JSON.parse(JSON.stringify(this.list))
          const params = {
            spId: this.information,
            purchaseProductsVoList: []
          }
          queryParams.forEach((item) => {
            const i = {}
            i.purchasePrice = item.purchasePrice
            i.proId = item.proId
            i.proCount = item.proCount
            i.proExtype = item.proExtype
            i.ocExtime = item.ocExtime
            params.purchaseProductsVoList.push(i)
          })
          purchaseContractBase(params)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('已生成合同，请设置合同账期！')
                this.$router.push({
                  name: 'createContract',
                  query: { type: '待审核', pcbId: res.data.obj }
                })
                this.queryBySpId()
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      } else if (type === 2) {
        if (this.supplierData.deductionAmount < this.deductionAmountPurcase) {
          this.$message.error('抵扣总额不能大于供应商抵扣金额！')
        } else {
          this.params.isOpenExtime = this.checked ? 1 : 0
          purchaseContractBaseUpdate(this.params)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message.success('提交审批成功')
                this.$router.push({
                  name: 'purchaseContractList'
                })
              }
            })
            .catch((err) => {
              console.log(err)
            })
        }
      } else if (type === 3) {
        updatePurchaseApprovalState(this.$route.query.pcbId, 6)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('合同作废成功')
              this.$router.push({
                name: 'purchaseContractList'
              })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      } else if (type === 4) {
        updatePurchaseApprovalState(this.$route.query.pcbId, 1)
          .then((res) => {
            if (res.data.code === 200) {
              this.$message.success('重新发起审批成功')
              this.$router.push({
                name: 'createContract',
                query: { type: '待审核', pcbId: this.$route.query.pcbId }
              })
              this.queryBySpId()
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.look-text {
  font-size: 12px;
  color: #d35e5e;
  height: 20px;
  line-height: 20px;
}
</style>
